import api from './api';

const colorsService = {
  async getColors() {
    const res = await api.get('/admin/colors');
    return res.data.colors;
  }
};

export default colorsService;
